import {t} from "i18next"; // Import the i18n instance

export const CLIENT_ORDER_STATUSES = ['all', 'moderation', 'awaitingpayment', 'awaiting-loading',
    'inprocess', 'completed', 'canceled'];

export const EXPEDITOR_ORDER_STATUSES = ['all', 'booked', 'confirmed', 'inprocess', 'waitingforcompletion', 'completed'];

export const ORDER_STATUSES_DATA = (t) => ({
    'moderation': { title: t('mockData.orderStatuses.moderation'), color: '#FF8502' },
    'booked': { title: t('mockData.orderStatuses.booked'), color: '#FA1861' },
    'waitloadingcargo': { title: t('mockData.orderStatuses.waitloadingcargo'), color: '#3A50C6' },
    'published': { title: t('mockData.orderStatuses.published'), color: '#2857FC' },
    'awaitingpayment': { title: t('mockData.orderStatuses.awaitingpayment'), color: '#FBC334' },
    'processloadingcargo': { title: t('mockData.orderStatuses.processloadingcargo'), color: '#3A50C6' },
    'processunloadingcargo': { title: t('mockData.orderStatuses.processunloadingcargo'), color: '#0275d8' },
    'loadingcargomoderation': { title: t('mockData.orderStatuses.loadingcargomoderation'), color: '#3A50C6' },
    'unloadingcargomoderation': { title: t('mockData.orderStatuses.unloadingcargomoderation'), color: '#0275d8' },
    'rejectedunloadingcargomoderation': { title: t('mockData.orderStatuses.rejectedunloadingcargomoderation'), color: '#3A50C6' },
    'waitstarttrip': { title: t('mockData.orderStatuses.waitstarttrip'), color: '#3A50C6' },
    'confirmed': { title: t('mockData.orderStatuses.confirmed'), color: '#0275d8' },
    'unloadingcargo': { title: t('mockData.orderStatuses.unloadingcargo'), color: '#048848' },
    'loadingcargo': { title: t('mockData.orderStatuses.loadingcargo'), color: '#048848' },
    'onthetrip': { title: t('mockData.orderStatuses.onthetrip'), color: '#048848' },
    'waitcompletion': { title: t('mockData.orderStatuses.waitcompletion'), color: '#40AD45' },
    'completed': { title: t('mockData.orderStatuses.completed'), color: '#212121' },
    'rejected': { title: t('mockData.orderStatuses.rejected'), color: '#A3ACB6' },
    'canceled': { title: t('mockData.orderStatuses.canceled'), color: '#A3ACB6' },
    'awaitingoffer': { title: t('mockData.orderStatuses.awaitingoffer'), color: '#FF8502' },
    'assigned': { title: t('common.status.statuses.assigned') ?? 'Назначен', color: '#212121' },
});
  

export const INVOICE_STATUSES_DATA = {
    'awaitingpayment': {title: 'Не оплачен', color: '#f0be39'},
    "paid": {title: 'Оплачен', color: '#5cb85c'},
}

export const ACTIVE_DATA = [
    {name: 'По актуальности', code: 'status'},
    {name: 'По дате создания заявки', code: 'createDate'},
    {name: 'По стоимости', code: 'price'},
]

// export const ORDER_STATUSES_DATA = { // Keep commented out section as is
//     'published': {title: 'ДОСТУПЕН', color: '#f0be39'}, 
//     'booked': {title: 'НА РАССМОТРЕНИИ', color: '#f0ad4e'}, 
//     'confirmed': {title: 'НАЗНАЧЕН', color: '#5cb85c'}, 
//     'inprocess': {title: 'В ПУТИ', color: '#0275d8'}, 
//     'completed': {title: 'ВЫПОЛНЕН', color: '#A3195B'}
// }

export const EXPEDITOR_TABS = (t) => [
  { key: "all", statuses: ["all"], title: t('mockData.expeditorTabs.all') },
  { key: "published", statuses: ["published"], title: t('mockData.expeditorTabs.published') },
  { key: "booked", statuses: ["booked", "confirmed"], title: t('mockData.expeditorTabs.booked') },
  { key: "processLoadingCargo", statuses: ["processloadingcargo", "loadingcargomoderation", "waitstarttrip"], title: t('mockData.expeditorTabs.processLoadingCargo') },
  { key: "onthetrip", statuses: ['unloadingcargo', 'loadingcargo', 'onthetrip'], title: t('mockData.expeditorTabs.onthetrip') },
  { key: "unloadingCargo", statuses: ["waitcompletion", "processunloadingcargo", "unloadingcargomoderation"], title: t('mockData.expeditorTabs.unloadingCargo') },
  { key: "completed", statuses: ["completed"], title: t('mockData.expeditorTabs.completed') },
];

export const ORDER_STATUSES = {
    all: t ("mockData.orderStatusLabels.all"),
    moderation: t ("mockData.orderStatusLabels.moderation"),
    awaitingpayment: t ("mockData.orderStatusLabels.awaitingpayment"),
    published: t ("mockData.orderStatusLabels.published"),
    booked: t ("mockData.orderStatusLabels.booked"),
    confirmed: t ("mockData.orderStatusLabels.confirmed"),
    processloadingcargo: t ("mockData.orderStatusLabels.processloadingcargo"),
    loadingcargomoderation: t ("mockData.orderStatusLabels.loadingcargomoderation"),
    rejectedloadingcargomoderation: t ("mockData.orderStatusLabels.rejectedloadingcargomoderation"),
    waitstarttrip: t ("mockData.orderStatusLabels.waitstarttrip"),
    onthetrip: t ("mockData.orderStatusLabels.onthetrip"),
    processunloadingcargo: t ("mockData.orderStatusLabels.processunloadingcargo"),
    unloadingcargomoderation: t ("mockData.orderStatusLabels.unloadingcargomoderation"),
    rejectedunloadingcargomoderation: t ("mockData.orderStatusLabels.rejectedunloadingcargomoderation"),
    completed: t ("mockData.orderStatusLabels.completed"),
    rejected: t ("mockData.orderStatusLabels.rejected"),
    canceled: t ("mockData.orderStatusLabels.canceled")
};

export const ORDER_STATUSES_KEY = {
    moderation: "moderation",
    awaitingpayment: "awaitingpayment",
    assigned: "assigned",
    published: "published",
    booked: "booked",
    confirmed: "confirmed",
    processloadingcargo: "processloadingcargo",
    loadingcargomoderation: "loadingcargomoderation",
    rejectedloadingcargomoderation: "rejectedloadingcargomoderation",
    waitstarttrip: "waitstarttrip",
    onthetrip: "onthetrip",
    processunloadingcargo: "processunloadingcargo",
    unloadingcargomoderation: "unloadingcargomoderation",
    rejectedunloadingcargomoderation: "rejectedunloadingcargomoderation",
    completed: "completed",
    rejected: "rejected",
    canceled: "canceled"
}

export const REJECT_STATUSES = {
    reject: "reject",
    rejectbook: "rejectbook",
    rejectloadingcargo: "rejectloadingcargo",
    rejectunloadingcargo: "rejectunloadingcargo"
}

export const acceptstatus = (status) => {
    switch (status) {
        case ORDER_STATUSES_KEY.assigned:
            return ORDER_STATUSES_KEY.published;
            break;
        case ORDER_STATUSES_KEY.unloadingcargomoderation:
            return ORDER_STATUSES_KEY.completed;
            break;
    }
}

export const rejectstatus = (status) => {
    switch (status) {
        case ORDER_STATUSES_KEY.moderation:
            return REJECT_STATUSES.reject;
            break;
        case ORDER_STATUSES_KEY.booked:
            return REJECT_STATUSES.rejectbook;
            break;
        case ORDER_STATUSES_KEY.loadingcargomoderation:
            return REJECT_STATUSES.rejectloadingcargo;
            break;
        case ORDER_STATUSES_KEY.unloadingcargomoderation:
            return REJECT_STATUSES.rejectunloadingcargo;
            break;
    }
}
